















































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'
import { SortOrder, UserDetailStateInfo } from '@/types'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    items: [
      {
        name: 'name',
        headerText: '氏名',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '80',
    items: [
      {
        name: 'nameKana',
        headerText: '氏名（カナ）',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserOldNameTableItem {
  id: number
  name: {
    input: string
    errorMessage: string
  }
  nameKana: {
    input: string
    errorMessage: string
  }
}

const defaultUserOldNameTableItem = (): UserOldNameTableItem => ({
  id: 0,
  name: {
    input: '',
    errorMessage: ''
  },
  nameKana: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    DataTable
  }
})
export default class UserOldNameTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserOldNameTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get sortedInputItems(): UserOldNameTableItem[] {
    if (this.sortName) {
      return orderBy<UserOldNameTableItem>(
        this.inputItems,
        (item: UserOldNameTableItem) => {
          switch (this.sortName) {
            case 'name':
              return item.name.input
            case 'nameKana':
              return item.nameKana.input
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.unshift(defaultUserOldNameTableItem())
  }

  remove(index: number): void {
    this.inputItems.splice(index, 1)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
